import React from 'react'
import SbEditable from 'storyblok-react'
import Heading from '@/components/Heading'
import RichText from '@/utils/RichText'
import { AuthorCard, type AuthorCardProps } from '@/components/ui/author-card'
import { SocialButton } from '@/components/ui/social-button'
import { ArticleBlockStoryblok } from '@/components/component-types-sb'

export const ArticleBlock = ({ blok }: ArticleBlockStoryblok) => {
  const marginTopClass = blok.marginTop ? `${blok.marginTop}px` : ''
  const marginBottomClass = blok.marginBottom ? `${blok.marginBottom}px` : ''
  return (
    // @ts-ignore: Storyblok typing issue with children
    <SbEditable content={blok} key={blok._uid}>
      <div
        data-testid="article-block-container"
        className="mx-auto px-4 max-w-6xl"
        style={{
          marginTop: marginTopClass,
          marginBottom: marginBottomClass,
        }}
      >
        <div className="space-y-2 flex flex-col gap-12 items-start justify-between">
          {blok.label && (
            <p className="text-sm md:text-base font-medium">{blok.label}</p>
          )}
          {blok.title && (
            <Heading size="h3" className={"tracking-wide"}>
              <RichText>{blok.title}</RichText>
            </Heading>
          )}
        </div>

        <div className="font-display space-y-2 flex flex-col gap-2 items-start justify-between mt-12 mb-12 text-left">
          <RichText>{blok.content}</RichText>
          {/*@INFO: Author card */}
        </div>
        <div className="mb-10">
          {blok.author[0] && (
            <AuthorCard
              position="left"
              {...blok.author[0]}
              socialLinks={{
                linkedin: blok.author[0].linkedin,
                x: blok.author[0].x,
                facebook: blok.author[0].facebook,
              }}
            />
          )}
        </div>


        <div className="flex flex-col items-center gap-2">
          <div className="text-darkblue uppercase text-sm font-medium ">
            share
          </div>
          <div className="flex items-center gap-2 px-3 py-2 border border-gray-200 rounded-full">
            <SocialButton type="linkedin" url={blok.author[0].linkedin || ''} />
            <SocialButton type="x" url={blok.author[0].x || ''} />
            <SocialButton type="email" url={blok.author[0].email || ''} />
            <SocialButton type="facebook" url={blok.author[0].facebook || ''} />
          </div>
        </div>
      </div>
    </SbEditable>
  )
}
ArticleBlock.displayName = 'ArticleBlock'
